import { CREDITS_BALANCE } from "@src/constants/credit-constants";
import { companyCreditBalanceSelector } from "@store/sdb-company/sdb-company-selector";
import { useAppSelector } from "@store/store-helper";
import { useEffect, useState } from "react";

interface Props {
  /** Determine if new indication like badge or info alert should be visible about news purchased token if not added yet */
  shouldShowNewIndication: boolean;
}

/** Custom hook to have util function related to token purchase */
export function useTokenPurchase(): Props {
  const companyCreditBalance: number = useAppSelector(
    companyCreditBalanceSelector
  );
  const [shouldShowNewIndication, setShouldShowNewIndication] =
    useState<boolean>(false);

  useEffect(() => {
    /** Balance that stored in local storage before initiating the purchase */
    const currentBalance = localStorage.getItem(CREDITS_BALANCE);

    if (!currentBalance) {
      return;
    }

    const balanceAmount = parseFloat(currentBalance);
    if (balanceAmount >= companyCreditBalance) {
      // Show the new credit badge if amount in local storage is larger or equal of companyCreditBalance
      // That means balance is not added yet
      setShouldShowNewIndication(true);
    } else if (balanceAmount < companyCreditBalance) {
      // If the companyCreditBalance is larger than amount in local storage, that means amount is added
      // In that case no need to show the badge, and amount in local storage is removed
      localStorage.removeItem(CREDITS_BALANCE);
      setShouldShowNewIndication(false);
    }
  }, [companyCreditBalance]);

  return {
    shouldShowNewIndication,
  };
}
